import { createI18n } from "vue-i18n";
import dayjs from "dayjs";
import { languages, defaultLanguage, fallbackLanguage, messages } from "./language-bundle";
export { languages, defaultLanguage } from "./language-bundle";

const key = "office.ui_language";
function savedLanguage() {
  try { return localStorage.getItem(key); } catch { return null; }
}
const initial = savedLanguage();
export const i18n = createI18n({
  legacy: false, globalInjection: true,
  locale: languages.some(item => item.code === initial) ? initial : defaultLanguage,
  fallbackLocale: fallbackLanguage, messages,
});
export function setUiLanguage(code) {
  if (!languages.some(item => item.code === code)) return;
  i18n.global.locale.value = code;
  document.documentElement.lang = code;
  dayjs.locale(code);
  try { localStorage.setItem(key, code); } catch { /* The current session still works. */ }
}
export function restoreUiLanguage(user) {
  if (user?.language_code) setUiLanguage(user.language_code);
}

// Outgoing system labels use the customer language, not the moderator UI.
export function recipientText(user, key, values = {}) {
  const code = Object.hasOwn(messages, user?.language_code) ? user.language_code : defaultLanguage;
  return i18n.global.t(key, values, { locale: code });
}
export function formatNumber(value, options = {}) {
  return new Intl.NumberFormat(i18n.global.locale.value, options).format(value);
}
export function formatDate(value, options = {}) {
  return new Intl.DateTimeFormat(i18n.global.locale.value, options).format(new Date(value));
}
setUiLanguage(i18n.global.locale.value);
